export default "__VITE_ASSET__XngDD9Iw__"